import * as angular from "angular"
import { defineDirective, IOmniaShell, isAdmin, ITypedStock, StockType } from "../omnia"
import { IMmExport, IStocksService } from "../types"
import { StockEditCtrl } from "./edit"


export abstract class TypedStockEditCtrl {

    static create(type: (new (...args: any[]) => ng.IController), template): ng.IDirective {

        var def = defineDirective(type, template, {
            stock: "=",
            exports: "="
        });

        def.require = "^omniaStocksEdit";

        def.link = TypedStockEditCtrl.link;

        return def;

    };

    private static link(scope, elt, attrs, parent: StockEditCtrl) {

        var ctrl: TypedStockEditCtrl = scope["vm"];

        ctrl.parentCtrl = parent;
        ctrl.stocks = parent.stocks;
        ctrl.setupInternal();

        parent.setCurrentEditor(ctrl);

    }

    static $inject = ["$scope"];

    protected parentCtrl: StockEditCtrl;

    protected stocks: IStocksService;
    protected stock: ITypedStock;
    protected newStock: boolean;

    protected exports: IMmExport[];

    public requiredAmount: number;

    public form: ng.IFormController;
    public showValidationErrors: boolean;


    constructor(protected $scope: ng.IScope,
        public readonly shell: IOmniaShell,
        public readonly readOnly = shell.isReadOnly(p => p.stocks) || (shell.config.features.stocks.v2 && (!isAdmin(shell))),
        public readonly showCosts = shell.permissions.stocks.financialData
    ) {

    }

    protected abstract getStockType(): StockType;

    public abstract commit(): ng.IPromise<any>;

    private setupInternal() {

        this.$scope.$watch("vm.stock", () => {

            if (!this.stock) {

                this.stock = {
                    StockId: 0,
                    StockType: this.getStockType(),
                    HoldingId: this.stocks.holdingId,
                    YearId: this.stocks.yearId
                };

            }

            this.newStock = !this.stock.StockId;

            this.requiredAmount = this.stock.ReqdAmount;

            this.setup();

        });

    }

    protected setup() {
    }

    get duplicate(): boolean {
        return this.parentCtrl && this.parentCtrl.duplicate;
    }

    public isUsedInPlans(): boolean {
        if (this.duplicate) return false;
        return this.stock && this.stock.Plans && (this.stock.Plans.length > 0);
    }

    protected hasErrors(field: string): boolean {

        if (this.form) {
            var c: ng.INgModelController = this.form[field];
            return (c && c.$invalid);
        }

    }

    protected prepareCommitModel<T extends ITypedStock>(stock: T): T {

        stock = <T>angular.extend({}, stock);

        stock.Plans = null;

        if (this.duplicate) {

            stock.StockId = 0;
            stock.SeedStockId = 0;
            stock.FertiliserStockId = 0;
            stock.ManureStockId = 0;
            stock.ReqdAmount = null;

        }

        return stock;

    }

    public canCommit(): boolean {
        return this.form && this.form.$valid;
    }

}
